export default "<div class=\"map\" id=\"map{{num}}\" [ngClass]=\"{'confirmation-map': confirmationPage}\"> \n</div>";